import controller from './show.controller';
import template from './show.html';

function RouteConfig($stateProvider) {
	'ngInject';

	$stateProvider
		.state('app.private.waybill.show', {
			controller,
			template,
			'controllerAs': 'vm',
			'url': '/show?busId&date&seats',
			'resolve': {
				'Waybill': function($filter, $stateParams, $state, BusComponent, Toast) {
					'ngInject';

					return BusComponent.fetchWaybill($stateParams.busId, $stateParams.date)
						.then(function(res) {
							if (res.data && res.data.errors) {
								Toast.responseError(res.data.errors);
								$state.go('app.private.waybill.chooseBus');
							} else if (res.data.data && !res.data.data.seats.length) {
								Toast.error($filter('translate')('NOT_FOUND.SOLD_TICKETS'));
								$state.go('app.private.waybill.chooseBus');
							} else {
								return res.data.data;
							}
						});
				}
			}
		});
}

export default RouteConfig;



/** WEBPACK FOOTER **
 ** ./client/private/waybill/show/show.route.js
 **/